// Routing (reacting to a route)
// on created()
// if there is bldg parm, it will getBuilding
// then() if there is room param, it will getRoom

<template>
	<v-container ref="fullPage" :style="darkTheme ? 'background-color: black;' : 'background-color: white;'" fluid class="fullpage">
	
	<SnackMessageBar />   
	<v-layout column >
		<dvAdminMenu />

		<v-toolbar height="80">
	  				  
		    <v-flex xs3>
 				<v-autocomplete outline
 					class="mt-2"
					ref="autocomplete"
					v-model="selectedBuilding"
					hide-no-data
					auto-select-first
					autocomplete
					clearable
					style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
					:items="buildings"
					:filter="customFilter"
					label="Building Name / Number / Addr"
					single-line
					>
					<template
				        slot="selection"
				        slot-scope="{ item, tile }"
				      >
				      	<v-layout v-if="selectedBuilding" v-on:click="selectedBuilding = null">
				        <v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
				        	{{item.bldgAlpha}}
				        </v-list-tile-avatar>
				        <v-list-tile-content>
				          <v-list-tile-title>
				          	{{item.name}}
				          </v-list-tile-title>
				          <v-list-tile-sub-title v-text="item.address"></v-list-tile-sub-title>
				        </v-list-tile-content>
				    	</v-layout>
				      </template>
					<template
				        slot="item"
				        slot-scope="{ item, tile }"
				      >
				        <v-list-tile-avatar dark tile color="grey darken-3" style="color: white;">
				        	{{item.bldgAlpha}}
				        </v-list-tile-avatar>
				        <v-list-tile-content>
				          <v-list-tile-title>
				          	{{item.name}}
				          </v-list-tile-title>
				          <v-list-tile-sub-title v-text="item.address"></v-list-tile-sub-title>
				        </v-list-tile-content>
				      </template>
				</v-autocomplete>


            </v-flex>
           
            <v-flex class = "ml-3">
			  	<v-toolbar-title class="ml-5 topTitle">	
			  			<v-layout align-center row fill-height>			
						<img src="@/images/ua_block_rgb_3.3c82a4c.png" class="blocka">
						<a href="/bldgviewer" 
							style="text-decoration: none;"
							:style="darkTheme ? 'color: whitesmoke;' : 'color: black;'"> 
								Space Database 
						</a>
						
					 	</v-layout>
				</v-toolbar-title>	
			</v-flex>
			
				{{this.userProfile.netid}}
				<v-icon v-if="isSuperUser" medium color="red" class="pl-2">verified_user</v-icon>
				<DBToggleBtn/>


	        <v-btn large icon class="grey--text text--darken-2" 
	        	@click="mapReload">
	        	<v-icon large >close</v-icon>
	        </v-btn>

  		</v-toolbar>

  		<v-layout column class="my-3 mx-3" >
  			<v-layout row  >
  				
		  		<v-flex xs6 class="ml-4">
		  			<BuildingDetail v-if="building" />
		  		</v-flex>

		  		<v-flex xs6 class="ml-4">
		  			<FloorDetail v-if="floor && building.floors.length > 0" />
					<v-toolbar flat class="slimtoolbar" v-else>
						<v-toolbar-title >ADD FLOOR</v-toolbar-title><v-spacer></v-spacer>
						<v-toolbar-items v-if="isSuperUser" style="position: relative; top: -5px; right: -20px;"  >
							<EditFloorDialog slot="activator" :icon="'add_circle_outline'" :newFlr="true" />
						</v-toolbar-items>
						</v-toolbar>
		  		</v-flex>

  			</v-layout>


  		
  		</v-layout>

	</v-layout>
	</v-container>
</template>


<script>
import Vuex from 'vuex'
import { mapState, mapActions, mapMutations } from 'vuex'

import BuildingDetail from '@/components/forms/BldgViewer/BuildingDetail'
import FloorDetail from '@/components/forms/BldgViewer/FloorDetail'
import EditBuildingDialog from './EditBuildingDialog'
import DBToggleBtn from '@/components/DBToggleBtn'
import dvAdminMenu from './dvAdminMenu'
import EditFloorDialog from '@/components/forms/BldgViewer/EditFloorDialog'


import SnackMessageBar from '@/components/SnackMessageBar'

export default {
name: 'bldgviewer',
components : { BuildingDetail, FloorDetail, EditBuildingDialog, DBToggleBtn, dvAdminMenu, SnackMessageBar, EditFloorDialog },

data () {
	return {
				loading: false			
	}
},

created: function () {
	if (this.$route.params.dvbldg) { 
		this.getBuilding(this.$route.params.dvbldg) 
	}
},

watch: {
	building (val) { 
		
	}
},

computed: {
	...mapState({   buildings: state => state.space.buildings,
					depts: state => state.lists.depts,
					deptBuildings: state => state.dv.deptBuildings,
					building: state => state.dv.building,
					darkTheme: state => state.ui.darkTheme,
					isSuperUser: state => state.user.isSuperUser,
					userProfile: state => state.user.userProfile,
					floor: state => state.dv.floor,
					
				}),

	

    buildingNameNumberFilter: {
	                get () {
	                  return this.$store.state.dv.buildingNameNumberFilter
	                },
	                set (value) {
	                    this.setBuildingNameNumberFilter(value)
	                }
    },

    selectedBuilding : {
	    get () {
	    	return this.building ? this.building.bldgAlpha : null
	    },

	    set (value) {	
	    	//console.log("AutoComplete Value: ", value)
	    	if (value) {
	    		this.getBuilding(value, "no_room_route")
	    	}	    	
	    }
	},

    

	

	buildingFloors: function () {
		return this.building ? this.building.floors : null
	},

	
},

methods : {
	...mapMutations([   'setdvBuilding',
						'setBuildingNameNumberFilter',						
						'setdvFloor',
						'updatedvAdminSidebar',
						'setdvBuildingRooms'
    				]),

	...mapActions  ([	
						'fetchBuilding',
						'fetchFloor',
						
						'refreshBuilding'
				    ]),

	

	getBuilding: function (bldgAlpha, no_room_route) {
		
		this.refreshBuilding(bldgAlpha).then(() => {
			if (!no_room_route && this.$route.params.dvroom) { this.getRoom(bldgAlpha, this.$route.params.dvroom) }
		})

		this.setdvBuildingRooms(null)
		
		/*this.fetchBuilding(bldgAlpha).then((data) => { 
			this.setdvBuilding(data) 
			this.fetchFloor({bldgAlpha: bldgAlpha, floor: this.building.floors[0]}).then((data) => this.setdvFloor(data))
		})*/

		/*this.fetchBuildingRooms(bldgAlpha).then((data) => { 
			this.setdvBuildingRooms(data)			
		})*/		
	},

	customFilter (item, queryText, itemText) {
		//return JSON.stringify(item).toLowerCase().indexOf(queryText.toLowerCase()) > -1 
		
        const bldgAlpha = item.bldgAlpha.toLowerCase()
        const searchBlob = 	item.bldgAlpha + item.name + item.address + item.city + item.state + item.abbrev + 
        					item.commonName + item.shortName + item.aliasName

        // If Search is 3 or less, use only the bldgAlpha.  Otherwise search the blob.
        if (queryText.length > 3 ) {
        	return searchBlob.toLowerCase().indexOf(queryText.toLowerCase()) > -1
        } else {
        	return bldgAlpha.indexOf(queryText.toLowerCase()) > -1 
        }
    },

	clearBuilding: function () {
		
		this.setBuildingNameNumberFilter(null)
		
		this.setdvBuildingRooms(null)
		
		this.setdvBuilding(null)
	},

	mapReload: function () {
        this.$router.push({ name: 'home' })
    }

},
}

</script>


<style>

.deptAuto .v-label  {
	font-size: 14px !important;

}

.slimtoolbar > .v-toolbar__content {
	height: 40px !important;
}

.slimtoolbar .v-toolbar__title {
	overflow: unset;
}

.tightlist > .v-list__tile {
	height: auto;
	padding-top: 1px;
	padding-bottom: 1px;
}

.full-height .flex {
    display: flex;
}

.full-height .flex > .card {
    flex: auto;
}

.fullpage {
display: absolute;
flex-direction: column;
flex: 1;
z-index: 10;
position: fixed;
top: 0px;
width: 100vw;
background-color: rgba(255, 255, 255, 1);
padding: 0px !important;
margin-top: 0px;
height: 100%;
overflow: hidden;
}

</style>



// WEBPACK FOOTER //
// src/components/forms/BldgViewer/BldgViewer.vue